module.exports = "<div class=\"time-table-summary-table\">\n  <div>\n    <div *ngFor=\"let col of cols\"></div>\n  </div>\n</div>\n"